<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";
const locale = await getLocale("forms", "cyberweby_warning");

defineProps({
	progress: { type: Number, required: true },
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "decline"]);
onMounted(() => {
	emit("init");
});
</script>

<template>
	<FormContainer :progress="progress">
		<FormCard :title="locale.title" @submit.prevent="emit('submit')" :submit-text="locale.submit" :header-class="'pageTitle mb-4'">
			<p class="pb-4" v-html="locale.paragraph1"/>
			<ul class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4 items-start">
				<li class="flex items-center justify-between space-x-4">
					<div class="flex items-center w-[50px]">
						<IconsFingerprintSecure class="block" />
					</div>
					<div class="w-fit">
						<p v-html="locale.icon_text_protection"/>
					</div>
				</li>
				<li class="flex items-center justify-between space-x-4">
					<div class="flex items-center w-[50px]">
						<IconsInternetSecurity class="block" />
					</div>
					<div class="w-fit">
						<p v-html="locale.icon_text_security"/>
					</div>
				</li>
				<li class="flex items-center justify-between space-x-4">
					<div class="flex items-center w-[50px]">
						<IconsLegalConsultation class="block" />
					</div>
					<div class="w-fit">
						<p v-html="locale.icon_text_legal"/>
					</div>
				</li>
			</ul>
			<p v-html="locale.paragraph2"/>
		</FormCard>

		<div class="text-center text-gray-700 pb-14">
			<button data-testid="decline" class="underline cursor-pointer" @click.prevent=" emit('decline')" v-text="locale.decline" type="button" />
		</div>
	</FormContainer>
</template>

<style scoped></style>
